import React from 'react';

import CheckBox from 'sharedreact/components/CheckBox';

type Props = {
  className?: string,
  checked: boolean,
  id: string,
  label: React.ReactNode,
  toolTip?: string,
  disabled?: boolean,
  radioButton?: boolean,
  
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
};

class RadioButton extends React.PureComponent<Props> {
  override render (): React.ReactNode {
    return <CheckBox radioButton {...this.props} />;
  }
}

export default RadioButton;
